import Seo from "./Seo";
import {
  buildarticlesDescription,
  buildarticlesJsonLd,
  buildarticlesKeywords,
} from "../utils/ArticleSeo";

type ArticleSeoProps = {
  articles: any;
  canonicalPath: string;
};

const ArticleSeo = ({ articles, canonicalPath }: ArticleSeoProps) => {
  if (!articles) return null;

  const title =
    articles?.pageTitle ||
    articles?.ogTitle ||
    (articles?.name
      ? `${articles.name} | Gita Seva`
      : "Gita Seva Articles");

  const description =
    articles?.pageDescription ||
    articles?.ogDescription ||
    buildarticlesDescription(articles);

  const keywords = buildarticlesKeywords(articles);

  const image =
    articles?.ogImage ||
    articles?.articlePath ||
    "";

  const jsonLd = buildarticlesJsonLd(
    articles,
    canonicalPath
  );

  return (
    <Seo
      title={title}
      description={description}
      keywords={keywords}
      path={canonicalPath}
      image={image}
      ogImageWidth={1200}
      ogImageHeight={630}
      ogType="article"
      robots="index,follow"
      jsonLd={jsonLd}
    />
  );
};

export default ArticleSeo;